<div class="row">
  <div class="col-md-12">
    <div id="chart">
      <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [xaxis]="chartOptions.xaxis"
        [markers]="chartOptions.markers"
        [stroke]="chartOptions.stroke"
        [yaxis]="chartOptions.yaxis"
        [dataLabels]="chartOptions.dataLabels"
        [title]="chartOptions.title"
        [tooltip]="chartOptions.tooltip"
        [legend]="chartOptions.legend"
      ></apx-chart>
    </div>
  </div>
</div>
